export const developmentPlanConstants = {

    // REQUEST DEVELOPMENT PLAN 
    REQUEST_DEVELOPMENT_PLAN: 'REQUEST_DEVELOPMENT_PLAN',
    RECEIVE_DEVELOPMENT_PLAN: 'RECEIVE_DEVELOPMENT_PLAN',
    DEVELOPMENT_PLAN_ERROR: 'DEVELOPMENT_PLAN_ERROR',

    // GET RELATION LISTS
    REQUEST_RELATION_LIST:'REQUEST_RELATION_LIST',
    RECEIVE_RELATION_LIST:'RECEIVE_RELATION_LIST',
    RELATION_LIST_ERROR:'RELATION_LIST_ERROR',

    // UPDATE RESPONDENTS
    REQUEST_UPDATE_RESPONDENTS:'REQUEST_UPDATE_RESPONDENTS',
    RECEIVE_UPDATE_RESPONDENTS:'RECEIVE_UPDATE_RESPONDENTS',
    UPDATE_RESPONDENTS_ERROR:'UPDATE_RESPONDENTS_ERROR',

    // UPDATE RELATION LIST
    REQUEST_UPDATE_RELATIONLIST:'REQUEST_UPDATE_RELATIONLIST',
    RECEIVE_UPDATE_RELATIONLIST:'RECEIVE_UPDATE_RELATIONLIST',
    UPDATE_RELATIONLIST_ERROR:'UPDATE_RELATIONLIST_ERROR',


};



// WEBPACK FOOTER //
// ./src/_constants/developmentPlan.constants.js